module.exports = __webpack_public_path__ + "img/48f5de2.jpg";